class WWGalleryController {
  constructor(gallery) {
    this.gallery = gallery;

    this.viewer = gallery.querySelector('#GalleryViewer-' + gallery.id.replace('MediaGallery-', ''));
    this.thumbnailSlider = gallery.querySelector('.thumbnail-slider');

    this.desktopLayout = gallery.dataset.wwDesktopLayout || 'left';
    this.mobileLayout = gallery.dataset.wwMobileLayout || 'bottom';

    if (!this.viewer || !this.thumbnailSlider) return;

    this.applyLayout();

    window.addEventListener('resize', () => this.applyLayout());
  }

  applyLayout() {
    const isDesktop = window.innerWidth >= 990;

    this.gallery.classList.remove(
      'ww-gallery-left',
      'ww-gallery-bottom',
      'ww-gallery-hidden'
    );

    if (isDesktop) {
      switch (this.desktopLayout) {
        case 'bottom':
          this.moveBottom();
          break;

        case 'hidden':
          this.hideThumbnails();
          break;

        default:
          this.moveLeft();
      }
    } else {
      switch (this.mobileLayout) {
        case 'hidden':
          this.hideThumbnails();
          break;

        default:
          this.moveBottom();
      }
    }
  }

  moveLeft() {
    this.thumbnailSlider.style.display = '';

    this.gallery.classList.add('ww-gallery-left');

    this.gallery.insertBefore(this.thumbnailSlider, this.viewer);
  }

  moveBottom() {
    this.thumbnailSlider.style.display = '';

    this.gallery.classList.add('ww-gallery-bottom');

    this.gallery.appendChild(this.thumbnailSlider);
  }

  hideThumbnails() {
    this.gallery.classList.add('ww-gallery-hidden');

    this.thumbnailSlider.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    new WWGalleryController(gallery);
  });
});